import styled from "styled-components";

/* Wrapper */
export const PageWrapper = styled.div`
  background: #f9fafb;
`;

/* Header */
export const Header = styled.div`
  display: flex;
  margin-bottom: 16px;
`;
export const ButtonGroup = styled("button")(() => ({
  display: "flex",
  justifyContent: "start",
  gap: "8px",
  border: "none",
  background: "none",
  boxShadow: "none",
}));

/* Button của bạn */
export const Button = styled("button")(() => ({
  padding: "10px 16px",
  borderRadius: 8,
  fontSize: 14,
  cursor: "pointer",
  border: "none",
  backgroundColor: "#2563eb",
  color: "#ffffff",
  "&.cancel": {
    backgroundColor: "#e5e7eb",
    color: "#111827",
  },
}));

/* Card */
export const Card = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`;

/* Title */
export const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
`;

/* Grid */
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

/* Field */
export const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-size: 13px;
  color: #374151;
  margin-bottom: 6px;
`;

export const Input = styled.input`
  height: 40px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #2563eb;
  }
`;

export const TextArea = styled.textarea`
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  min-height: 120px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #2563eb;
  }
`;
